import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DetailAdvPage, AdvEmployeePage } from '../';
import { User, Master } from '@providers/advance_providers';

@Component({
  selector: 'page-list-employee',
  templateUrl: 'page.html'
})
export class ListEmployeePage {

  user:any={};
  akses:any={};
  params:any = {};
  list:any=[];
  employee:any=[];
  panelSearch = false;
  organization : any=[];
  total_rows=0;

  loading : any;

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public loadingCtrl: LoadingController,
    public toastCtrl : ToastController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {

    if(this.navParams.get('params')!=undefined){
      this.params = this.navParams.get('params');
    }
    
    this.user = this.userApi.data;
    this.akses = this.userApi.akses;

    if(this.userApi.akses.lihat_advance_employee_group_data=="all" && this.navParams.get('params')==undefined){
      this.params.all_direktorat = 1,
      this.params.all_company    = 1,
      this.params.all_divisi     = 1,
      this.params.all_branch     = 1
    }

    if(this.userApi.akses.lihat_advance_employee_group_data=='direktorat' && this.navParams.get('params')==undefined){
        this.params.all_company    = 1,
        this.params.all_divisi     = 1,
        this.params.advance_type   = 'HO',
        this.params.branch_ids     = '00,00',
        this.params.directorat_ids = this.userApi.data.directorat_maping_id
    }else if(this.userApi.akses.lihat_advance_employee_group_data=='divisi' && this.navParams.get('params')==undefined){     
        this.params.all_company    = 1;
        this.params.advance_type   = 'HO',
        this.params.branch_ids     = '00,00',
        this.params.division_ids   = this.userApi.data.division_maping_id
    }else if(this.userApi.akses.lihat_advance_employee_group_data=='branch' && this.navParams.get('params')==undefined){
        this.params.all_company    = 1;
        this.params.advance_type   = 'branch',
        this.params.branch_ids     = this.userApi.data.hrm_company_office_id,
        this.params.company_ids    = this.userApi.data.company_id
    }

    // if(this.navParams.get('organization') != undefined){
    //   this.organization = this.navParams.get('organization');
    // }

    console.log('list employee params => ', this.params)

  }

  ionViewDidEnter(){
    this.getEmployee();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getEmployee();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Please wait ...'
    });
    this.loading.present();
  } 

  getEmployee(){
    this.showLoading();
    let params:any = this.params;
    // if(this.organization.unit_path_id != undefined){
    //   params.hrm_employee_id = this.user.employee_id,
    //   params.unit_path_id = this.organization.unit_path_id,
    //   params.unit_path_id2 = this.organization.unit_path_id2
    // }
    this.masterApi.getEmployee(params).subscribe((resp:any) => {
      this.employee = resp.data;
      this.total_rows = this.employee.length;
      console.log("data employee = ",resp.data);
      this.loading.dismiss();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });

    console.log('organization => ', this.organization.unit_path_id);
  }

  getBusinessOrganization(){
    let params:any={}
    this.masterApi.getOrganization(params).subscribe((resp:any) => {
      this.organization = resp.data;
    });
  }

  toDetailAdvance(id, item){
    this.navCtrl.push(DetailAdvPage, {
      id:id,
      item:item
    });
  }

  getAdvEmployee(user_nik, name){
    this.navCtrl.push(AdvEmployeePage, {
      user_nik:user_nik,
      employee_name: name
    });
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }

  presentToast(msg){
    this.toastCtrl.create({
      message : msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  showSearch(){
    this.panelSearch = true;
  }
  hideSearch(){
    this.panelSearch = false;
  }

  onInput(e){
    this.getEmployee();
  }

  onCancel(e){
    this.getEmployee();
  }



}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/list_employee/page.ts